import React from 'react'
import { withStyles } from 'material-ui/styles'
import MuiButton from 'material-ui/Button'
import classeNames from 'classnames'

const styles = theme => ({
  big: {
    height: 50,
    fontSize: 20,
    padding: 25,
  },
})

const Button = ({ classes, big, className, innerClasses, ...props }) => (
  <MuiButton
    className={classeNames(className, { [classes.big]: big })}
    classes={innerClasses}
    {...props}
  />
)

Button.muiName = 'Button'

export default withStyles(styles)(Button)



// WEBPACK FOOTER //
// ./src/components/Button.js